"use client";

import { useState, useEffect, useMemo, useTransition } from "react";
import style from "./DegreeProgramListDetails.module.scss";
import { ProgramFilterContainer } from "./ProgramFilterContainer";
import ProgramListing from "./ProgramListing";
import { programMap } from "../utils";
import {
  paytmTechPrograms1,
  paytmTechPrograms2,
  mbaCareerRestartPathway,
  medaversityPrograms,
  ricsPage,
} from "./ProgramListing";

const dataProgram1 = [medaversityPrograms, paytmTechPrograms1, mbaCareerRestartPathway, ricsPage, paytmTechPrograms2];
const dataProgram2 = ["mba", "bba", "mca", "bca", "b.com"];
const getArrangePrograms = (programs = []) => {
  let remaining = [...programs];
  let specializationPrograms = [];
  const result = [];

  const filterDataParameter1Based = () => {
    for (const keywordArr of dataProgram1) {
      for (const keyword of keywordArr) {
        const matched = remaining.filter((item) =>
          programMap[item?.programName]?.toLowerCase()?.includes(keyword),
        );
        result.push(...matched);
        remaining = remaining.filter(
          (item) =>
            !programMap[item?.programName]?.toLowerCase()?.includes(keyword),
        );
      }
    }
  };

  const filterDataParameterBased = (isSpecialization = false) => {
    if (isSpecialization) {
      for (const keyword of dataProgram2) {
        const matched = specializationPrograms.filter((item) =>
          programMap[item?.programName]?.toLowerCase()?.includes(keyword),
        );
        result.push(...matched);
        specializationPrograms = specializationPrograms.filter(
          (item) =>
            !programMap[item?.programName]?.toLowerCase()?.includes(keyword),
        );
      }
    } else {
      for (const keyword of dataProgram2) {
        const matched = remaining.filter((item) =>
          programMap[item?.programName]?.toLowerCase()?.includes(keyword),
        );
        result.push(...matched);
        remaining = remaining.filter(
          (item) =>
            !programMap[item?.programName]?.toLowerCase()?.includes(keyword),
        );
      }
    }
  };

  const filterWithoutSpecialization = (programs) => {
    specializationPrograms = programs?.filter(
      (item) => item?.__typename === "SpecializationEntity",
    );
    remaining = programs?.filter(
      (item) => item?.__typename !== "SpecializationEntity",
    );
  };

  filterDataParameter1Based();
  filterWithoutSpecialization(remaining);

  filterDataParameterBased(false);
  filterDataParameterBased(true);

  result.push(...specializationPrograms);
  result.push(...remaining);

  return result;
};

/* Make the MBA program first among others for All courses and Specializations sections */
const rearrangeMBAProgramRank = programs => {
    if (!programs?.length) return programs;

    const targetSlug = "mba-in-project-management";
    const rankedPrograms = [
      ...programs.filter((program) => program?.attributes?.slug === targetSlug || program?.attributes?.BasicDetails?.url_key === `/${targetSlug}`),
      ...programs.filter((program) => program?.attributes?.slug !== targetSlug && program?.attributes?.BasicDetails?.url_key !== `/${targetSlug}`),
    ];

    return rankedPrograms;
};

export default function ProgramListDetails({
  DegreePrograms,
  country,
  certificationProgram,
  schoolOfAIDetailsProgram,
  isAffiliatePage = false,
  landingPageValue = "",
  isLandingPage = false,
  isProgramListPage = false,
}) {
  const [filteredProgramList, setFilteredProgramList] =
    useState(DegreePrograms);
  const [courseType, setCourseType] = useState({
    id: 1,
    name: "All Courses",
    filterName: "",
  });

  const [subCourseType, setSubcourseType] = useState({
    id: 0,
    name: "Trending",
    filterName: "Trending",
  });

  const [isFirstIteration, setIsFirstIteration] = useState(true);
  const [isFirstIterationSubcourseType, setIsFirstIterationSubcourseType] =
    useState(true);
  const [isPending, startTransition] = useTransition();
  useEffect(() => {
    if (!isFirstIteration) {
      const courseTypeFilter = courseType?.filterName;
      const subCourseTypeFilter = subCourseType?.filterName;
      let filteredItems = [];
      if (courseType?.id === 5) {
        setSubcourseType({
          id: 5,
          name: "School of AI",
          filterName: "SCHOOL_OF_AI",
        });
        filteredItems = [...certificationProgram];
      } else {
        filteredItems = DegreePrograms?.filter((item) => {
          let matchCourseType = true;

          if (courseTypeFilter) {
            if (courseTypeFilter === "Specialization") {
              matchCourseType = item?.__typename === "SpecializationEntity";
            } else {
              matchCourseType = item?.programType === courseTypeFilter;
            }
          }

          return matchCourseType;
        });
      }
      startTransition(() => {
        setFilteredProgramList(filteredItems);
      });
    } else {
      setIsFirstIteration(false);
    }
  }, [courseType]);

  useEffect(() => {
    if (!isFirstIterationSubcourseType) {
      const subCourseTypeFilter = subCourseType?.filterName;
      const isTrendingSubType = subCourseType?.filterName == "Trending";

      let filteredItems = [];

      if (courseType?.id === 5) {
        if (subCourseTypeFilter === "KPMG") {
          filteredItems = certificationProgram;
        } else if (subCourseTypeFilter === "SCHOOL_OF_AI") {
          filteredItems = schoolOfAIDetailsProgram;
        } else {
          filteredItems = [
            ...schoolOfAIDetailsProgram,
            ...certificationProgram,
          ];
        }
      } else {
        const courseTypeFilter = courseType?.filterName;
        filteredItems = DegreePrograms?.filter((item) => {
          let matchCourseType = true;
          let matchSubcourseType = true;

          if (courseTypeFilter) {
            if (courseTypeFilter === "Specialization") {
              matchCourseType = item?.__typename === "SpecializationEntity";
            } else {
              matchCourseType = item?.programType === courseTypeFilter;
            }
          }

          if (subCourseTypeFilter && !isTrendingSubType) {
            matchSubcourseType = item?.domain === subCourseTypeFilter;
          }

          return matchCourseType && matchSubcourseType;
        });
      }
      startTransition(() => {
        setFilteredProgramList(filteredItems);
      });
    } else {
      setIsFirstIterationSubcourseType(false);
    }
  }, [subCourseType]);

  const arrangePrograms = useMemo(() => {
    return courseType?.id !== 5
      ? getArrangePrograms(filteredProgramList)
      : filteredProgramList;
  }, [filteredProgramList]);

const programsWithMbaOnTop = useMemo(() => {
  const shouldPrioritizeMBA =
    (courseType?.name === "All Courses" ||
      courseType?.name === "Specializations") &&
    subCourseType?.name === "Trending";

  return shouldPrioritizeMBA
    ? rearrangeMBAProgramRank(arrangePrograms)
    : arrangePrograms;
}, [arrangePrograms, courseType?.name, subCourseType?.name]);

  return (
    <>
      <div className={style.root}>
        <ProgramFilterContainer
          setCourseType={setCourseType}
          setSubcourseType={setSubcourseType}
          courseType={courseType}
          subCourseType={subCourseType}
          isCertificationFilterSelected={courseType?.id === 5}
          isAffiliatePage={isAffiliatePage}
          landingPageValue={landingPageValue}
          isLandingPage={isLandingPage}
        />
      </div>
      <div
        className="my-3 relative"
        style={{
          opacity: isPending ? 0.6 : 1,
          transition: "opacity 150ms ease",
        }}
      >
        {filteredProgramList.length > 0 ? (
          <ProgramListing
            programs={programsWithMbaOnTop}
            isCertificationList={courseType?.id === 5}
            isSchoolOfAIList={courseType?.id === 6}
            country={country}
            isAffiliatePage={isAffiliatePage}
            isProgramListPage={isProgramListPage}
          />
        ) : (
          <div className={style.no_data_found}>-- No Data Found --</div>
        )}
      </div>
    </>
  );
}
